<template>
  <v-btn
    color="#0F1F38"
    dark
    rounded
    elevation="2"
    class="chat-btn"
    @click="openFreshchat"
  >
    <v-icon :left="!isMobile">mdi-headset</v-icon>
    <span v-if="!isMobile">Chat</span>
  </v-btn>
</template>

<script>
export default {
  name: "FreshchatButton",

  data() {
    return {
      isMobile: false,
      watcher: null,
    };
  },

  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);

    this.startFreshchatWatcher();
  },

  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);

    if (this.watcher) {
      clearInterval(this.watcher);
    }
  },

  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 600;
    },

    openFreshchat() {
      this.waitForFreshchat()
        .then(() => {
          this.showFreshchatFrame();

          setTimeout(() => {
            window.fcWidget.open();
          }, 150);
        })
        .catch(() => {
          console.warn("Freshchat no está disponible todavía.");
        });
    },

    startFreshchatWatcher() {
      this.watcher = setInterval(() => {
        if (!window.fcWidget) return;

        const frame = document.getElementById("fc_frame");
        if (!frame) return;

        if (window.fcWidget.isOpen && window.fcWidget.isOpen()) {
          this.showFreshchatFrame();
        } else {
          this.hideFreshchatFrame();
        }
      }, 300);
    },

    showFreshchatFrame() {
      const frame = document.getElementById("fc_frame");

      if (frame) {
        frame.style.display = "block";
        frame.style.visibility = "visible";
        frame.style.opacity = "1";
        frame.style.zIndex = "999999";
      }
    },

    hideFreshchatFrame() {
      const frame = document.getElementById("fc_frame");

      if (frame) {
        frame.style.display = "none";
        frame.style.visibility = "hidden";
        frame.style.opacity = "0";
      }
    },

    waitForFreshchat() {
      return new Promise((resolve, reject) => {
        let attempts = 0;

        const interval = setInterval(() => {
          attempts++;

          if (window.fcWidget && document.getElementById("fc_frame")) {
            clearInterval(interval);
            resolve();
          }

          if (attempts >= 30) {
            clearInterval(interval);
            reject();
          }
        }, 250);
      });
    },
  },
};
</script>

<style scoped>
.chat-btn {
  text-transform: none !important;
  font-weight: 600;
  letter-spacing: 0.3px;
  min-width: 110px;
}

/* Mobile: solo icono */
@media (max-width: 599px) {
  .chat-btn {
    min-width: 42px !important;
    width: 42px !important;
    height: 42px !important;
    padding: 0 !important;
    border-radius: 50% !important;
  }

  .chat-btn .v-icon {
    margin: 0 !important;
  }
}
</style>